import * as React from 'react'

import styled from '@theme/styled-components'

import { List } from 'react-virtualized'

interface Props {
  data: CompanyGroup[]
  renderItem: (item: CompanyGroup, idx: number) => React.ReactElement
  openedTab: boolean[]
}

// Liste avec une hauteur de ligne dynamique en fonction du nombre d'entreprises par regroupement
const DynamicList: (props: Props) => React.ReactElement = ({ data, renderItem, openedTab }) => {
  const container = React.useRef<HTMLDivElement>(null)
  const [containerSize, setContainerSize] = React.useState({ width: 0, height: 0 })
  const [key, setKey] = React.useState(0)

  const renderRow = ({ index, key, style }: { index: number; key: string; style: any }) => (
    <div style={style}>{renderItem(data[index], index)}</div>
  )

  React.useEffect(() => {
    if (container.current) {
      setContainerSize({
        height: container.current.clientHeight,
        width: container.current.clientWidth,
      })
    }
    setKey((key) => key + 1) // pour re-render la liste
  }, [data, openedTab])

  const getRowHeight = React.useCallback(
    ({ index }: any) => {
      if (openedTab[index]) {
        return data[index].companies.length * 100 + 100 // 100px pour le regroupement + 100px par entreprise du regroupement
      } else {
        return 100 // que la ligne du regroupement
      }
    },
    [data, openedTab]
  )

  if (containerSize.height === 0) {
    return <Empty ref={container} />
  }

  return (
    <List
      key={key}
      width={containerSize.width}
      height={containerSize.height}
      rowRenderer={renderRow}
      rowCount={data.length}
      rowHeight={getRowHeight}
    />
  )
}

export default DynamicList

const Empty = styled('div')`
  height: 100%;
  width: 100%;
`
